module.exports = __webpack_public_path__ + "static/img/EWallet.d00586f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/backoffice/EWallet.png
// module id = xek8
// module chunks = 0